export default "__VITE_ASSET__DaIKcMDk__"